import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getPersonalidades = query =>
	fetch.get(
		`/personalidades${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getPersonalidad = ({ id, query }) =>
	fetch.get(
		`/personalidades/${id}${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const addPersonalidad = data => fetch.post('/personalidades', data);
export const updatePersonalidad = ({ id, ...data }) =>
	fetch.put(`/personalidades/${id}`, data);
export const deletePersonalidad = id => fetch.delete(`/personalidades/${id}`);

// RTK Query
export const personalidadesApi = createApi({
	reducerPath: 'personalidadesApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getPersonalidades: build.query({
			query: query => {
				return {
					url: `/tbpr-personalidades${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({
								type: 'Personalidades',
								id,
							})),
							{ type: 'Personalidades', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'Personalidades', id: 'LIST' }],
		}),
		getPersonalidad: build.query({
			query: ({ id, query }) => {
				return {
					url: `/tbpr-personalidades/${id}${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'Personalidades', id }],
		}),
		addPersonalidad: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/tbpr-personalidades`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Personalidad agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar personalidad');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'Personalidades', id: 'LIST' }],
		}),
		updatePersonalidad: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/tbpr-personalidades/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Personalidad actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar personalidad');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [
				{ type: 'Personalidades', id },
			],
		}),
		deletePersonalidad: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/tbpr-personalidades/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Personalidad eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar personalidad');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [
				{ type: 'Personalidades', id },
			],
		}),
	}),
});

export const {
	useGetPersonalidadesQuery,
	useGetPersonalidadQuery,
	useAddPersonalidadMutation,
	useUpdatePersonalidadMutation,
	useDeletePersonalidadMutation,
} = personalidadesApi;
